// extracted by mini-css-extract-plugin
export default {"recos":"i6-z","productCardOverride":"j6-z","rowHasBadge":"k6-z"};